import Select from './Select'

export const PROCEDURE_MATCHES = [
  { id: 'all', name: 'Procedure Match: all' },
  { id: 'matched', name: 'OK' },
  { id: 'mismatched', name: 'Wrong Order' },
]

export default function ProcedureMatchSelect(props) {
  return <Select allowClear={false} {...props} options={PROCEDURE_MATCHES} />
}
